import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import { AdProviders, adunitMemo, ADUNIT_MAP } from '../../../constants';
import { useAdUnit } from '../../../useAdUnit';
const MobileDevPageSide300x250 = /*#__PURE__*/ React.memo(({ safety = 'off', safetyState })=>{
    const _useAdUnit = useAdUnit(AdProviders.Gak, ADUNIT_MAP['UserMobileDevPageSide300x250Gam'], safety, safetyState, {
        refreshLimit: 30,
        refreshTimeout: 240000,
        size: [
            [
                180,
                150
            ],
            [
                300,
                50
            ],
            [
                234,
                60
            ],
            [
                120,
                240
            ],
            [
                300,
                250
            ],
            [
                250,
                250
            ],
            [
                320,
                100
            ],
            [
                300,
                100
            ],
            [
                300,
                200
            ],
            [
                320,
                250
            ],
            [
                320,
                50
            ],
            [
                125,
                125
            ],
            [
                200,
                200
            ]
        ],
        targeting: {
            unitType: 'btf'
        }
    }), { advertIsOff } = _useAdUnit, slotAttr = _object_without_properties(_useAdUnit, [
        "advertIsOff"
    ]);
    if (advertIsOff === 'off') {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", slotAttr);
}, adunitMemo);
MobileDevPageSide300x250.displayName = 'MobileDevPageSide300x250';
export default MobileDevPageSide300x250;
